import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import YetsanLogo from './YetsanLogo';
import { useTeklifListesi } from '../context/TeklifListesiContext';
import { useTabSystem } from '../context/TabContext';
import { useYetki } from '../context/YetkiContext';
import { useState, useEffect, useCallback, useRef, Fragment } from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import { gorunurAralik } from '../utils/gorunurAralik';
import { useSekmeAktif } from '../utils/useYoklama';
import PanelNotification from './PanelNotification';
import DeviceTrustBell from './DeviceTrustBell';
import GunaydinDashboard from './GunaydinDashboard';
import TabBar from './TabBar';
import FirsatSeridi from './FirsatSeridi';
import { APP_VERSION } from './UpdatePopup';
import { useAktiviteTakip } from '../hooks/useAktiviteTakip';
import { getFirmaBaglami, getAktifFirma, setAktifFirma } from '../utils/aktifFirmaInterceptor';
import { CRM_AKTIF, BACTERIA_AKTIF, KAPALI_ETIKET, KAPALI_MESAJ, BACTERIA_KAPALI_MESAJ } from '../constants/modulDurum';

import { 
  LayoutDashboard, 
  UserPlus,
  ScanSearch,
  Package, 
  Users,
  ShoppingCart,
  FileText,
  LogOut,
  Plus,
  Ship,
  FileCheck,
  Settings,
  ClipboardList,
  BarChart3,
  Tag,
  Warehouse,
  Sparkles,
  Percent,
  CreditCard,
  Database, Wrench,
  DollarSign,
  Megaphone,
  Bell,
  TrendingUp,
  Flame,
  Building2,
  Activity,
  RefreshCw,
  Dna,
  LifeBuoy,
  Camera,
  Shield,
  Clock,
  Zap,
  Smartphone,
  Star,
  Radar,
  CalendarRange,
  Wallet, RotateCcw, Target, Truck }
from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Sipariş izni sayacının son değeri — tüm sol menü kopyaları paylaşır (çift sesli uyarı olmasın)
let _sonSiparisIzni = { kim: null, sayi: null };

// Rol bazlı sayfa erişim tanımları
const ROL_YETKILERI = {
  client: ['anasayfa', 'urunler', 'sepetim', 'musteri-cari', 'uyelik', 'adreslerim', 'sifre-degistir', 'siparislerim'],
  musteri: ['anasayfa', 'urunler', 'sepetim', 'musteri-cari', 'uyelik', 'adreslerim', 'sifre-degistir', 'siparislerim'],  // musteri = client ile aynı
  // 'arac-satis' hiçbir rolde yok: KİŞİ BAZLI — Kullanıcı Yönetimi → kişinin Yetkiler'indeki
  // tik açar; backend etkin yetkisi (sayfaGorebilir) belirler.
  firma: ['anasayfa', 'urunler', 'resim-ihtiyaci', 'yeni-siparis', 'siparisler', 'teklifler', 'hizli-teklif', 'teklif-listesi', 'cari', 'taleplerim', 'yoldaki-urunlerim', 'destek-talep'],
  mudur: ['anasayfa', 'urunler', 'resim-ihtiyaci', 'yeni-urun', 'yeni-siparis', 'siparisler', 'teklifler', 'hizli-teklif', 'teklif-listesi', 'cari', 'taleplerim', 'fiyat-talepleri', 'musteriler', 'raporlar', 'talep-radari', 'planlama', 'ithalat', 'depo-transfer', 'yari-mamul', 'yoldaki-urunlerim', 'kredi-karti-provizyon', 'kasa', 'fiyat-yonetimi', 'iskonto-onay', 'destek-talep', 'iade', 'tedarik-radari', 'stok-esitle', 'bacteria'],
  admin: ['anasayfa', 'urunler', 'resim-ihtiyaci', 'yeni-urun', 'promosyon-merkezi', 'yeni-siparis', 'siparisler', 'teklifler', 'hizli-teklif', 'teklif-listesi', 'cari', 'taleplerim', 'fiyat-talepleri', 'musteriler', 'raporlar', 'talep-radari', 'planlama', 'ithalat', 'depo-transfer', 'yari-mamul', 'wms', 'yoldaki-urunlerim', 'ayarlar', 'kullanici-yonetimi', 'kredi-karti-provizyon', 'kasa', 'fiyat-yonetimi', 'sistem-yonetimi', 'iskonto-onay', 'destek-talep', 'bacteria', 'iade', 'tedarik-radari', 'stok-esitle', 'bayi-basvurulari'],
  superadmin: ['*'] // Tüm sayfalara erişim
};

const sayfaYetkisiVar = (userRole, sayfa) => {
  if (!userRole) return false;
  const yetkiler = ROL_YETKILERI[userRole] || [];
  return yetkiler.includes('*') || yetkiler.includes(sayfa);
};

const PanelSidebar = ({ isOpen, setIsOpen }) => {
  const { user, logout, isMusteriUser } = useAuth();
  const { teklifSayisi } = useTeklifListesi();
  const { forceOpenTab, openTab, isTabEnabled } = useTabSystem();
  const navigate = useNavigate();
  const [siparisMenuAcik, setSiparisMenuAcik] = useState(false);
  const [satisMenuAcik, setSatisMenuAcik] = useState(false);
  const [satinAlmaMenuAcik, setSatinAlmaMenuAcik] = useState(false);
  const [bekleyenSiparisler, setBekleyenSiparisler] = useState(0);
  const [satisBekleyen, setSatisBekleyen] = useState(0);
  const [satinAlmaBekleyen, setSatinAlmaBekleyen] = useState(0);
  const [bekleyenTransferler, setBekleyenTransferler] = useState(0);
  const [sepetSayisi, setSepetSayisi] = useState(0);
  // 💎 Sepetteki kampanyali urun bilgisi (Gorev 2)
  const [sepetKampanya, setSepetKampanya] = useState({ kampanyali_sayi: 0, toplam_tasarruf: 0, kampanyali_urunler: [] });
  
  // 🆕 Bekleyen fiyat talepleri
  const [bekleyenFiyatTalepleri, setBekleyenFiyatTalepleri] = useState(0);
  const [benimTaleplerimBekleyen, setBenimTaleplerimBekleyen] = useState(0);

  // 🆕 CRM bekleyen görev sayısı (Günaydın'dan atanan tahsilat/arama vs)
  const [bekleyenCrmGorev, setBekleyenCrmGorev] = useState(0);
  const [gecikenCrmGorev, setGecikenCrmGorev] = useState(0);
  
  // Bekleyen iskonto onay talepleri
  const [bekleyenIskontoOnay, setBekleyenIskontoOnay] = useState(0);
  const [bekleyenSiparisIzni, setBekleyenSiparisIzni] = useState(0);
  const [bekleyenPlanlama, setBekleyenPlanlama] = useState(0);   // Talep Radarı planlama (aktif)
  const [yeniBayiBasvuru, setYeniBayiBasvuru] = useState(0);     // otoradyator.com bayi başvurusu (yeni)
  
  // Yoldaki ürün sayısı (yanıp sönen badge için)
  const [yoldakiUrunSayisi, setYoldakiUrunSayisi] = useState(0);
  const [aktifKampanyaSayisi, setAktifKampanyaSayisi] = useState(0);
  const [kisiselKampanyaSayisi, setKisiselKampanyaSayisi] = useState(0);
  
  // Kullanıcı rolü
  const userRole = user?.role || 'firma';
  const isClient = userRole === 'client' || userRole === 'musteri';
  const isMusteriKullanici = isClient || (isMusteriUser ? isMusteriUser() : false);
  const isYonetici = ['mudur', 'admin', 'superadmin'].includes(userRole);
  const tabEnabled = isTabEnabled(userRole);

  // ⚡ Hızlı Erişim — SADECE superadmin: seçilen menüleri üste sabitle.
  //
  // HESABA BAĞLI (cihaza değil): tercih `users.ui_tercihleri.hizli_erisim`de durur,
  // kullanıcı hangi bilgisayardan/tarayıcıdan girerse girsin kendi düzeniyle gelir.
  // localStorage BIRAKILDI ama artık kaynak değil, iki işi var:
  //   1) İLK BOYAMA — sunucu yanıtı beklenirse menü sırası gözle görülür şekilde
  //      zıplıyor. Önce yereldeki son bilinen düzenle çizilir, sunucu gelince eşitlenir.
  //   2) ÇEVRİMDIŞI/HATA — sunucuya ulaşılamazsa düzen kaybolmasın.
  const isSuper = userRole === 'superadmin';
  const userId = user?.id || user?.user_id || user?.email || '';
  const qaKey = `yetsan_sidebar_qa_${userId}`;
  const [hizliErisim, setHizliErisim] = useState([]); // pinli path dizisi (sıra korunur)
  const qaYuklendi = useRef(false);

  useEffect(() => {
    qaYuklendi.current = false;
    if (!isSuper || !userId) { setHizliErisim([]); return; }
    let iptal = false;

    // 1) Yerelden anında boya
    let yerel = [];
    try {
      const v = JSON.parse(localStorage.getItem(qaKey) || '[]');
      yerel = Array.isArray(v) ? v : [];
    } catch { yerel = []; }
    setHizliErisim(yerel);

    // 2) Sunucudan eşitle
    (async () => {
      try {
        const { data } = await axios.get(`${API}/panel/tercihler`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
        if (iptal) return;
        const sunucu = data?.tercihler?.hizli_erisim;
        if (Array.isArray(sunucu) && sunucu.length) {
          setHizliErisim(sunucu);
          try { localStorage.setItem(qaKey, JSON.stringify(sunucu)); } catch {}
        } else if (yerel.length) {
          // Sunucuda kayıt yok ama bu tarayıcıda düzen var → bir kereye mahsus
          // yukarı taşı. Eski kullanıcılar pinlerini kaybetmesin.
          axios.put(`${API}/panel/tercihler`, { hizli_erisim: yerel }, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }).catch(() => {});
        }
      } catch { /* sessiz — yereldeki düzenle devam */ }
      finally { if (!iptal) qaYuklendi.current = true; }
    })();
    return () => { iptal = true; };
  }, [isSuper, userId, qaKey]);

  const toggleHizliErisim = (path) => {
    setHizliErisim(prev => {
      const next = prev.includes(path) ? prev.filter(p => p !== path) : [...prev, path];
      try { localStorage.setItem(qaKey, JSON.stringify(next)); } catch {}
      // İyimser kayıt: ekran anında tepki verir, yazma arkada gider.
      // Sunucu henüz okunmadıysa yazma — boş liste kullanıcının düzenini silebilir.
      if (qaYuklendi.current) {
        axios.put(`${API}/panel/tercihler`, { hizli_erisim: next }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
          .catch(() => toast.error('Hızlı erişim kaydedilemedi — bu cihazda geçerli'));
      }
      return next;
    });
  };

  // 🔐 Dinamik yetki: backend etkin yetkileri yüklendiyse onu kullan,
  // yüklenmediyse (eski sürüm / hata) statik ROL_YETKILERI'ne düş.
  const { sayfaGorebilir } = useYetki();
  const sayfaYetkiKontrol = (sayfa) => {
    const dinamik = sayfaGorebilir(sayfa);
    return dinamik !== null ? dinamik : sayfaYetkisiVar(userRole, sayfa);
  };

  // Tab sistemi aktifse NavLink yerine tab açma fonksiyonu
  // 🚦 Kapalı modüller — menüden GİRİLEMEZ (constants/modulDurum.js).
  //    Route'lar açık kalır; yalnız menü erişimi engellenir.
  const kapaliModulMesaji = useCallback((path) => {
    if (!BACTERIA_AKTIF && path.startsWith('/panel/bacteria')) return BACTERIA_KAPALI_MESAJ;
    if (!CRM_AKTIF && path.startsWith('/crm')) return KAPALI_MESAJ;
    return null;
  }, []);

  const handleNavClick = useCallback((e, path) => {
    const kapali = kapaliModulMesaji(path);
    if (kapali) { e.preventDefault(); toast.info(kapali); return; }
    if (tabEnabled) {
      e.preventDefault();
      const openFn = forceOpenTab || openTab;
      openFn(path);
      navigate(path);
    }
  }, [tabEnabled, forceOpenTab, openTab, navigate, kapaliModulMesaji]);
  
  // 🆕 Müşteri aktivite takibi - Global olarak başlatılıyor
  // Bu hook müşteri giriş yaptığında oturum başlatır ve sayfa gezinmelerini takip eder
  // Personelde her sayfa kendi sol menüsünü çizer ve TabLayout açık iç sekmeleri display:none ile bağlı
  // tutar → N iç sekme = N sol menü, hepsi aynı sayaçları soruyordu (2026-10-23). Yalnız öndeki sorar;
  // öne gelen sekme effect yeniden çalıştığı için hemen tazeler. Müşteride sekme sistemi yok → hep true.
  const sekmeAktif = useSekmeAktif();
  useAktiviteTakip({ otomatik: sekmeAktif });
  
  // 🆕 Bekleyen iskonto onay taleplerini çek
  useEffect(() => {
    if (!sekmeAktif) return;
    const fetchBekleyenIskontoOnay = async () => {
      if (!isYonetici) return;
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        
        const res = await axios.get(`${BACKEND_URL}/api/panel/iskonto-onay-bekleyen-sayisi`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          setBekleyenIskontoOnay(res.data.bekleyen_sayi || 0);
        }
      } catch (err) {
        console.log('İskonto onay sayısı alınamadı');
      }
    };
    
    fetchBekleyenIskontoOnay();
    return gorunurAralik(fetchBekleyenIskontoOnay, 60000);
  }, [isYonetici, sekmeAktif]);

  // 🤝 otoradyator.com bayi başvuruları — bakılmamış sayısı (yetkisi olmayana uç 0 döner)
  useEffect(() => {
    if (isMusteriKullanici || !sekmeAktif) return;
    const fetchYeniBasvuru = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const res = await axios.get(`${BACKEND_URL}/api/panel/bayi-basvurulari/yeni-sayisi`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) setYeniBayiBasvuru(res.data.sayi || 0);
      } catch (err) { /* menü rozeti: sessiz */ }
    };
    fetchYeniBasvuru();
    return gorunurAralik(fetchYeniBasvuru, 60000);
  }, [isMusteriKullanici, sekmeAktif]);

  // 📡 Talep Radarı — aktif planlama sayısı (badge)
  useEffect(() => {
    if (!sekmeAktif) return;
    const fetchBekleyenPlanlama = async () => {
      if (!isYonetici) return;
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const res = await axios.get(`${BACKEND_URL}/api/panel/gunun-hikayesi/planlama/bekleyen-sayisi`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) setBekleyenPlanlama(res.data.sayi || 0);
      } catch (err) {
        console.log('Planlama bekleyen sayısı alınamadı');
      }
    };
    fetchBekleyenPlanlama();
    return gorunurAralik(fetchBekleyenPlanlama, 60000);
  }, [isYonetici, sekmeAktif]);

  // 💳 Bekleyen açık hesap sipariş izni taleplerini çek (müdür/superadmin/özel onaylayıcı)
  //    + onaylayıcı role için sesli/aksiyonlu UYARI (yeni onay geldiğinde veya oturumda ilk kez)
  // Önceki sayı modül düzeyinde: iç sekme değişince öne gelen sol menü, öbürünün zaten uyardığı
  // siparişler için ikinci kez ses çalmasın.
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;
  useEffect(() => {
    // Müşteride bu liste yok (uç yetkisiz döner) — boşuna sorulmasın
    if (!sekmeAktif || isMusteriKullanici) return;
    const ONAYLAYICI_ROLLERI = ['mudur', 'superadmin', 'admin', 'yetsanadmin', 'ithaladmin'];
    const uyar = (adet, toplam, sesli) => {
      if (sesli) { try { new Audio('/sounds/notification.wav').play().catch(() => {}); } catch { /* noop */ } }
      toast.warning(
        adet > 0
          ? `💳 ${adet} yeni sipariş onayınızı bekliyor (toplam ${toplam}).`
          : `💳 ${toplam} sipariş onayınızı bekliyor.`,
        {
          duration: 12000,
          action: { label: 'Görüntüle', onClick: () => navigateRef.current('/panel/siparis-izni-talepleri') },
        }
      );
    };
    const fetchSiparisIzni = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        // sayi=1: rozet yalnız toplamı kullanır — tam liste (ürün stok + cari ünvan) sunucuda boşuna hazırlanmasın
        const res = await axios.get(`${BACKEND_URL}/api/panel/siparis-izni/bekleyen-siparisler?sayi=1`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const yeni = res.data?.success ? (res.data.toplam || (res.data.siparisler || []).length || 0) : 0;
        const kim = user?.email || userRole;
        const onceki = _sonSiparisIzni.kim === kim ? _sonSiparisIzni.sayi : null;  // başka kullanıcının sayısı sayılmaz
        const onaylayici = ONAYLAYICI_ROLLERI.includes(userRole);
        if (onaylayici) {
          if (onceki !== null && yeni > onceki) {
            // Yeni onay geldi (çalışırken) → sesli uyar
            uyar(yeni - onceki, yeni, true);
          } else if (onceki === null && yeni > 0 && sessionStorage.getItem('siparis_izni_uyarildi') !== '1') {
            // Oturumda ilk giriş, bekleyen var → bir kez uyar (sessiz)
            sessionStorage.setItem('siparis_izni_uyarildi', '1');
            uyar(0, yeni, false);
          }
        }
        _sonSiparisIzni = { kim, sayi: yeni };
        setBekleyenSiparisIzni(yeni);
      } catch (err) { /* sessiz */ }
    };
    fetchSiparisIzni();
    // Onaylayıcıya sesli uyarı verdiği için arka plandaki sekmede de seyrek sorulur (2 dk)
    return gorunurAralik(fetchSiparisIzni, 60000, 120000);
    // navigate bağımlılıkta DEĞİL: her sayfa geçişinde yeni fonksiyon döner → her geçişte istek atıyordu
  }, [userRole, user?.email, sekmeAktif, isMusteriKullanici]);

  // Yoldaki ürün sayısını çek (firma ve admin kullanıcıları için)
  useEffect(() => {
    if (!sekmeAktif) return;
    const fetchYoldakiUrunSayisi = async () => {
      if (isMusteriKullanici) return;
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const res = await axios.get(`${BACKEND_URL}/api/panel/yoldaki-urunler/aktif`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          setYoldakiUrunSayisi(res.data.count || 0);
        }
      } catch (err) {
        console.log('Yoldaki ürün sayısı alınamadı');
      }
    };
    fetchYoldakiUrunSayisi();
    return gorunurAralik(fetchYoldakiUrunSayisi, 120000);
  }, [isMusteriKullanici, sekmeAktif]);

  // 🔴 Aktif kampanya sayısı (müşteri için kişisel)
  useEffect(() => {
    const fetchKampanyaSayisi = async () => {
      try {
        const cariKodu = user?.cari_kodu;
        const url = cariKodu
          ? `${BACKEND_URL}/api/panel/kisisellestirme/aktif-kampanya-sayisi?cari_kodu=${encodeURIComponent(cariKodu)}`
          : `${BACKEND_URL}/api/panel/kisisellestirme/aktif-kampanya-sayisi`;
        const res = await axios.get(url);
        if (res.data.success) {
          setAktifKampanyaSayisi(res.data.toplam || 0);
          setKisiselKampanyaSayisi(res.data.kisisel || 0);
        }
      } catch (err) {
        // sessizce yoksay
      }
    };
    if (isMusteriKullanici) {
      fetchKampanyaSayisi();
      return gorunurAralik(fetchKampanyaSayisi, 300000); // 5dk, yalnız görünür sekmede
    }
  }, [user?.cari_kodu, isMusteriKullanici]);
  
  // 🆕 Bekleyen fiyat taleplerini çek
  useEffect(() => {
    if (!sekmeAktif) return;
    const fetchBekleyenTalepler = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        
        // Yöneticiler için tüm bekleyen talepler
        if (isYonetici) {
          const res = await axios.get(`${BACKEND_URL}/api/panel/fiyat-talep/bekleyen-sayisi`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (res.data.success) {
            setBekleyenFiyatTalepleri(res.data.count || 0);
          }
        }
        
        // Tüm kullanıcılar için kendi talepleri
        // limit=1: rozet yalnız sayıyı kullanır; sunucu durum=beklemede süzgecinin toplamını zaten döndürüyor
        // (eskiden her dakika 50 tam talep belgesi çekilip burada sayılıyordu — 2026-10-23)
        const resBenim = await axios.get(`${BACKEND_URL}/api/panel/fiyat-talepleri?talep_eden=${user?.email}&durum=beklemede&limit=1`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (resBenim.data.success || resBenim.data.talepler) {
          const talepler = resBenim.data.talepler || resBenim.data.data || [];
          const bekleyenler = typeof resBenim.data.toplam === 'number'
            ? resBenim.data.toplam
            : talepler.filter(t => t.durum === 'beklemede').length;
          setBenimTaleplerimBekleyen(bekleyenler);
        }
      } catch (err) {
        console.log('Bekleyen talepler alınamadı');
      }
    };
    
    fetchBekleyenTalepler();
    
    // Dakikada bir, yalnız görünür sekmede (arka plan sekmeleri sunucuyu doyuruyordu)
    return gorunurAralik(fetchBekleyenTalepler, 60000);
  }, [user?.email, isYonetici, sekmeAktif]);
  
  // Müşteri için sepet sayısını çek
  useEffect(() => {
    const fetchSepetSayisi = async () => {
      // Müşteri kullanıcı kontrolü - isMusteriKullanici zaten hesaplanmış
      if (!isMusteriKullanici) {
        console.log('[Sidebar] Müşteri değil, sepet sayısı atlanıyor. Role:', userRole);
        return;
      }
      
      // userId'yi tüm olası kaynaklardan al - öncelik sırası önemli
      const userId = user?.id || user?.user_id || user?._id || localStorage.getItem('userId');
      console.log('[Sidebar] UserId kontrol:', { 
        'user.id': user?.id, 
        'user.user_id': user?.user_id, 
        'user._id': user?._id,
        'localStorage': localStorage.getItem('userId'),
        'final': userId 
      });
      
      if (!userId) {
        console.log('[Sidebar] UserId bulunamadı!');
        return;
      }
      
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.log('[Sidebar] Token bulunamadı!');
          return;
        }
        
        // Yalnız sayaç: tam sepet (fiyat+kampanya+iskonto hesabı) her yoklamada hesaplanıp zaman aşımına düşüyordu
        const res = await axios.get(`${BACKEND_URL}/api/panel/sepet/${userId}/sayi`, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 10000 // 10 saniye timeout
        });
        if (res.data.success) {
          const toplam = Number(res.data.sayi) || 0;
          setSepetSayisi(toplam);
          console.log('[Sidebar] ✅ Sepet sayısı güncellendi:', toplam);
        }
      } catch (err) {
        console.log('[Sidebar] ❌ Sepet sayısı alınamadı:', err.message);
      }
    };
    
    // User objesi yüklenene kadar bekle
    if (!user) {
      console.log('[Sidebar] User henüz yüklenmedi, sepet sorgusu bekletiliyor');
      return;
    }
    
    // İlk yükleme
    fetchSepetSayisi();
    
    // Her 10 saniyede bir güncelle
    const durdur = gorunurAralik(fetchSepetSayisi, 60000);  // sepet değişince 'sepetGuncellendi' ile anında
    
    // Custom event listener - sepete ekleme sonrası anında güncelle
    const handleSepetGuncelle = () => {
      console.log('[Sidebar] sepetGuncellendi eventi alındı');
      fetchSepetSayisi();
    };
    window.addEventListener('sepetGuncellendi', handleSepetGuncelle);
    
    return () => {
      durdur();
      window.removeEventListener('sepetGuncellendi', handleSepetGuncelle);
    };
  }, [isMusteriKullanici, user, userRole]);

  // 💎 Sepetteki kampanyali urun durumu (Gorev 2)
  useEffect(() => {
    if (!isMusteriKullanici || !user) return;
    const fetchSepetKampanya = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${BACKEND_URL}/api/panel/kisisellestirme/sepet-kampanya-durum`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          timeout: 8000,
        });
        if (res.data?.success) {
          setSepetKampanya({
            kampanyali_sayi: res.data.kampanyali_sayi || 0,
            toplam_tasarruf: res.data.toplam_tasarruf || 0,
            kampanyali_urunler: res.data.kampanyali_urunler || [],
          });
        }
      } catch { /* sessizce yoksay */ }
    };
    fetchSepetKampanya();
    const durdur = gorunurAralik(fetchSepetKampanya, 120000);  // sepet değişince 'sepetGuncellendi' ile anında
    const onSepetUpdate = () => fetchSepetKampanya();
    window.addEventListener('sepetGuncellendi', onSepetUpdate);
    return () => {
      durdur();
      window.removeEventListener('sepetGuncellendi', onSepetUpdate);
    };
  }, [isMusteriKullanici, user]);

  // Müşteri (client) menüsü — kullanıcı tarafından istenen sıra:
  // Ana Sayfa → Fırsatlar → Ürün Kataloğu → Sepetim → Siparişlerim → Ön Siparişlerim
  // → Cari Hesabım → Adreslerim → Üyelik Bilgilerim → Şifre Değiştir
  // (Cihazlarım kaldırıldı — müşteri panelinde gösterilmeyecek)
  const musteriMenuItems = [
    { path: '/panel/anasayfa', icon: LayoutDashboard, label: 'Ana Sayfa' },
    { path: '/panel/urunler?firsat=true', icon: Flame, label: '🔥 Fırsatlar' },
    { path: '/panel/urunler', icon: Package, label: 'Ürün Kataloğu' },
    { path: '/panel/sepetim', icon: ShoppingCart, label: 'Sepetim', badge: sepetSayisi },
    { path: '/panel/siparislerim', icon: ClipboardList, label: 'Siparişlerim', badge: bekleyenSiparisler },
    { path: '/panel/on-siparis-firsatlari', icon: Ship, label: '🚢 Ön Sipariş Fırsatları' },
    { path: '/panel/on-siparislerim', icon: Ship, label: 'Ön Siparişlerim' },
    { path: '/panel/musteri-cari', icon: FileText, label: 'Cari Hesabım' },
    { path: '/panel/adreslerim', icon: LayoutDashboard, label: 'Adreslerim' },
    { path: '/panel/uyelik', icon: Users, label: 'Üyelik Bilgilerim' },
    { path: '/panel/sifre-degistir', icon: LogOut, label: 'Şifre Değiştir' },
  ];

  // Normal kullanıcı menüsü (firma, mudur, admin, superadmin)
  // Ana Sayfa yönlendirmesi: superadmin/müdür → Yönetici Dashboard, diğer firma rolleri → Firma Dashboard
  const yoneticiDashRoles = ['superadmin', 'mudur'];
  const firmaDashboardRoles = ['admin', 'firma_kullanicisi', 'firma', 'yonetici'];
  const anasayfaPath = yoneticiDashRoles.includes(userRole)
    ? '/yonetici-dashboard'
    : (firmaDashboardRoles.includes(userRole) ? '/panel/firma-dashboard' : '/panel/anasayfa');
  const normalMenuItems = [
    { path: anasayfaPath, icon: LayoutDashboard, label: 'Ana Sayfa', sayfa: 'anasayfa' },
    { path: '/panel/urunler', icon: Package, label: 'Ürün Yönetimi', sayfa: 'urunler' },
    { path: '/panel/resim-ihtiyaci', icon: Camera, label: '📷 Resim İhtiyacı', sayfa: 'resim-ihtiyaci', roles: ['firma', 'mudur', 'admin', 'superadmin', 'yetsanadmin'] },
    { path: '/panel/yeni-urun', icon: Plus, label: 'Yeni Ürün Kartı', sayfa: 'yeni-urun' },
    { path: '/panel/fiyat-yonetimi', icon: DollarSign, label: '💰 Fiyat Yönetimi', sayfa: 'fiyat-yonetimi' },
    { path: '/panel/promosyon-merkezi', icon: Sparkles, label: '📢 Kampanya ve Duyurular', sayfa: 'promosyon-merkezi' },
    { path: '/panel/panel-musterileri', icon: Users, label: 'Müşteri Yönetimi', sayfa: 'musteriler' },
    { path: '/panel/iskonto-onay', icon: Tag, label: '🏷️ İskonto Onay', badge: bekleyenIskontoOnay, sayfa: 'iskonto-onay' },
    { path: '/panel/cari-hesaplar', icon: Building2, label: 'Cari Hesaplar', sayfa: 'cari' },
    { path: '/panel/bayi-basvurulari', icon: UserPlus, label: '🤝 Bayi Başvuruları', badge: yeniBayiBasvuru, sayfa: 'bayi-basvurulari' },
    // Rol filtresi YOK: kişiye verilen tik açar (firma personeli dahil) — 2026-09-29
    { path: '/panel/arac-satis', icon: Truck, label: '🚚 Araçtan Satış', sayfa: 'arac-satis' },
    { path: '/panel/iade', icon: RotateCcw, label: '↩️ Satış İadesi', sayfa: 'iade',
      roles: ['mudur', 'admin', 'superadmin', 'yetsanadmin', 'ithaladmin'] },
    // Müdür: yalnız 4 stok sekmesi, kendi firması (sekme kısıtı BacteriaHub'da) — 2026-09-29
    { path: '/panel/bacteria', icon: Dna, label: 'Bacteria AI', sayfa: 'bacteria', roles: ['superadmin', 'yetsanadmin', 'admin', 'ithaladmin', 'mudur'] },
    { path: '/panel/teklifler', icon: FileCheck, label: 'Teklif Yönetimi', sayfa: 'teklifler' },
    { path: '/panel/siparis-izni-talepleri', icon: FileCheck, label: '💳 Sipariş İzni Talepleri', badge: bekleyenSiparisIzni, sayfa: 'siparis-izni-talepleri', roles: ['mudur', 'superadmin', 'admin', 'yetsanadmin', 'ithaladmin'] },
    { path: '/panel/teklif-listesi', icon: ClipboardList, label: 'Teklif Listesi', badge: teklifSayisi, sayfa: 'teklif-listesi' },
    { path: '/panel/depo-transfer', icon: TrendingUp, label: 'Depo Transfer İstekleri', badge: bekleyenTransferler, sayfa: 'depo-transfer' },
    { path: '/panel/yari-mamul', icon: Wrench, label: '🔧 Yarı Mamul', sayfa: 'yari-mamul' },
    { path: '/panel/stok-resync', icon: Database, label: '🔄 Stok Eşitleme (Logo)', sayfa: 'stok-esitle', roles: ['mudur', 'superadmin', 'admin', 'yetsanadmin', 'ithaladmin'] },
    { path: '/panel/ithalat', icon: Ship, label: 'İthalat Siparişleri', sayfa: 'ithalat' },
    { path: '/panel/on-satis-yonetim', icon: Ship, label: '🛒 Ön-Satış Yönetimi', sayfa: 'ithalat', roles: ['mudur', 'superadmin', 'admin', 'yetsanadmin', 'ithaladmin'] },
    { path: '/panel/yoldaki-urunlerim', icon: Ship, label: 'Yoldaki Ürünlerim', sayfa: 'yoldaki-urunlerim' },
    { path: '/panel/talep-radari', icon: Radar, label: '📡 Talep Radarı', sayfa: 'talep-radari', roles: ['mudur', 'superadmin', 'admin', 'yetsanadmin', 'ithaladmin'] },
    { path: '/panel/planlama', icon: CalendarRange, label: '📅 Planlama', badge: bekleyenPlanlama, sayfa: 'planlama', roles: ['mudur', 'superadmin', 'admin', 'yetsanadmin', 'ithaladmin'] },
  ].filter(item => {
    if (item.roles && !item.roles.includes(userRole)) return false;
    return sayfaYetkiKontrol(item.sayfa);
  });

  // 🎯 SADECE-ÖDEME kullanıcısı: yalnız Cari Hesabım + Şifre Değiştir (ürün/sepet/sipariş YOK)
  const odemeKullanicisi = user?.kullanici_tipi === 'kk_odeme';
  const odemeMenuItems = [
    { path: '/panel/musteri-cari', icon: FileText, label: 'Cari Hesabım' },
    { path: '/panel/sifre-degistir', icon: LogOut, label: 'Şifre Değiştir' },
  ];
  const menuItems = odemeKullanicisi ? odemeMenuItems : (isMusteriKullanici ? musteriMenuItems : normalMenuItems);

  // ⚡ Hızlı Erişim sıralaması (sadece superadmin): pinli olanlar üstte, kalanlar altta
  const qaSet = new Set(isSuper ? hizliErisim : []);
  const pinliMenu = isSuper ? hizliErisim.map(p => menuItems.find(it => it.path === p)).filter(Boolean) : [];
  const pinliCount = pinliMenu.length;
  const siraliMenu = isSuper
    ? [...pinliMenu, ...menuItems.filter(it => !qaSet.has(it.path))]
    : menuItems;

  const fetchBekleyenSiparisler = async () => {
    try {
      let url;
      
      const _baglam = getFirmaBaglami();
      const _yonetici = (_baglam?.yonetilen || []).length > 0;
      if (isMusteriKullanici && user?.cari_kodu) {
        url = `${BACKEND_URL}/api/panel/musteri-siparislerim/${encodeURIComponent(user.cari_kodu)}`;
      } else if (_yonetici) {
        // 🏢 Vekaleten yönetici: kendi + yönetilen firmaların bekleyenlerini BİRLİKTE say (kaçmasın)
        url = `${BACKEND_URL}/api/panel/siparisler?durum=beklemede,transfer_beklemede`;
      } else if (user?.firma) {
        url = `${BACKEND_URL}/api/panel/siparisler?firma=${user.firma}&durum=beklemede,transfer_beklemede`;
      } else {
        url = `${BACKEND_URL}/api/panel/siparisler?durum=beklemede,transfer_beklemede`;
      }
      
const res = await axios.get(url);
if (res.data.success) {
  const bekleyen = res.data.data.filter(s => 
    ['beklemede', 'transfer_beklemede'].includes(s.durum)
  );

  // Gruplu sayım
  const gruplar = new Set(bekleyen.map(s => s.grup_siparis_id || s._id));
  setBekleyenSiparisler(gruplar.size);

  // Satış: kaynak=firma VEYA firma=firma (hem satış hem transfer siparişleri)
  // Transfer siparişlerinde firma=AHYED ama kaynak da AHYED olabilir
  const userFirma = user?.firma || '';
  const satis = bekleyen.filter(s => 
    s.kaynak === userFirma || 
    s.kaynak_firma === userFirma || 
    (s.tip === 'transfer' && s.firma === userFirma)
  );
  const satisGruplar = new Set(satis.map(s => s.grup_siparis_id || s._id));
  setSatisBekleyen(satisGruplar.size);

  // Satınalma: hedef=firma transfer (gelen transferler)
  const satinAlma = bekleyen.filter(s => 
    s.tip === 'transfer' && 
    (s.hedef === userFirma || s.hedef_firma === userFirma || s.hedef_depo === userFirma)
  );
  const satinAlmaGruplar = new Set(satinAlma.map(s => s.grup_siparis_id || s._id));
  setSatinAlmaBekleyen(satinAlmaGruplar.size);
}

    } catch (err) {
      console.error('Sipariş sayısı alınamadı');
    }
  };

  const fetchBekleyenTransferler = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.log('🔴 Token bulunamadı, transfer badge yüklenemedi');
        return;
      }
      
      const res = await axios.get(`${BACKEND_URL}/api/panel/transfer-bekleyen-sayisi`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      console.log('📊 Transfer bekleyen sayısı API yanıtı:', res.data);
      
      if (res.data.success) {
        const bekleyenSayisi = res.data.data.bekleyen_sayisi;
        setBekleyenTransferler(bekleyenSayisi);
        console.log('✅ Transfer badge güncellendi:', bekleyenSayisi);
      }
    } catch (err) {
      console.error('❌ Transfer sayısı alınamadı:', err);
      console.error('Hata detayı:', err.response?.data);
    }
  };

  useEffect(() => {
    fetchBekleyenSiparisler();
    fetchBekleyenTransferler(); // Transfer sayısını da çek
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isMusteriKullanici]);

  // Kullanıcının firma kodunu al
  const userFirma = user?.firma || 'OTOMOTIV';

  // CRM bekleyen görev sayısını periyodik olarak çek (Günaydın'dan atanan)
  useEffect(() => {
    // CRM kapalıyken rozet gösterilmiyor → 60sn'lik anket'i hiç başlatma
    if (!CRM_AKTIF || !user || isMusteriUser) return;
    const fetchBekleyenGorev = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/panel/gunaydin-bekleyen-gorev`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data?.success) {
          setBekleyenCrmGorev(res.data.bekleyen || 0);
          setGecikenCrmGorev(res.data.geciken || 0);
        }
      } catch { /* sessiz */ }
    };
    fetchBekleyenGorev();
    return gorunurAralik(fetchBekleyenGorev, 60000);
  }, [user, isMusteriUser]);

  return (
    <>
      {/* Tab Bar - sidebar'ın sağ tarafında, content alanının üstünde */}
      <TabBar sidebarOpen={isOpen} />

      {/* Panel Bildirim Sistemi - Yeni sipariş/transfer uyarısı
          Bildirim, zil ve Günaydın yalnız öndeki iç sekmenin sol menüsünde: arkadakiler display:none
          olduğu hâlde her biri ayrı ayrı yokluyordu (sekmeAktif yukarıda). */}
      {!isMusteriKullanici && sekmeAktif && (() => {
        // 🏢 Vekaleten yönetici: canlı bildirim kendi + yönetilen firmaları kapsasın (ISTANBUL siparişi de ping'lesin)
        const _fb = getFirmaBaglami();
        const _yon = _fb?.yonetilen || [];
        const _bildirimFirma = _yon.length ? [_fb.firma, ..._yon].filter(Boolean).join(',') : userFirma;
        return <PanelNotification firma={_bildirimFirma} />;
      })()}

      {/* Device Trust Bell - Cihaz onay + güvenlik olaylar (admin/firma/mudur için) */}
      {!isMusteriKullanici && sekmeAktif && ['firma', 'mudur', 'admin', 'superadmin', 'yetsanadmin'].includes(userRole) && (
        <div className="fixed top-4 right-4 z-[60]">
          <DeviceTrustBell />
        </div>
      )}

      {/* Günaydın Dashboard - Sabah brifingi (müdür/admin/superadmin) */}
      {!isMusteriKullanici && sekmeAktif && <GunaydinDashboard />}
      
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <div className={`
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        ${isOpen ? 'w-64' : 'lg:w-16 w-64'}
        fixed lg:relative
        bg-white shadow-xl transition-all duration-300 h-screen flex flex-col z-50
      `}>
        <div className="p-3 sm:p-4 border-b border-gray-200 bg-indigo-600 text-white">
          <div className="flex items-center justify-between">
            {isOpen && (
              <div>
                <h1 className="flex items-center"><YetsanLogo beyaz boy={18} sistem="PANEL" /></h1>
                <span className="mt-1.5 inline-block text-[10px] bg-white/20 px-2 py-0.5 rounded-full font-mono">v{APP_VERSION}</span>
                <div className="flex flex-wrap gap-1 mt-1.5">
                  {sayfaYetkiKontrol('cari') && (
                  <button 
                    onClick={() => {
                      // 🚦 CRM kapalıyken menüden GİRİLEMEZ (yarım işlem riski) — constants/modulDurum.js
                      if (!CRM_AKTIF) { toast.info(KAPALI_MESAJ); return; }
                      if (tabEnabled) { const fn = forceOpenTab || openTab; fn('/crm/dashboard'); navigate('/crm/dashboard'); } 
                      else { window.location.href = '/crm/dashboard'; }
                    }}
                    className={`flex items-center gap-1 text-[10px] font-bold px-2.5 py-1 rounded-full transition-all shadow-sm relative ${CRM_AKTIF
                      ? 'bg-gradient-to-r from-violet-600 to-purple-600 text-white hover:from-violet-500 hover:to-purple-500 cursor-pointer'
                      : 'bg-slate-500/60 text-slate-200 cursor-not-allowed'}`}
                    title={CRM_AKTIF ? 'CRM' : KAPALI_MESAJ}
                    data-testid="sidebar-crm-btn"
                  >
                    CRM
                    {CRM_AKTIF ? (
                      <span className="animate-pulse bg-white/25 text-[8px] px-1 py-0.5 rounded-full font-bold">YENi</span>
                    ) : (
                      <span className="bg-white/20 text-[8px] px-1 py-0.5 rounded-full font-bold">{KAPALI_ETIKET}</span>
                    )}
                    {CRM_AKTIF && bekleyenCrmGorev > 0 && (
                      <span
                        className={`ml-0.5 text-[9px] px-1.5 py-0.5 rounded-full font-bold ${gecikenCrmGorev > 0 ? 'bg-rose-500 text-white animate-pulse' : 'bg-amber-400 text-amber-900'}`}
                        title={`${bekleyenCrmGorev} bekleyen görev${gecikenCrmGorev > 0 ? ` (${gecikenCrmGorev} geciken)` : ''}`}
                        data-testid="sidebar-crm-gorev-badge"
                      >
                        {bekleyenCrmGorev}
                      </span>
                    )}
                  </button>
                  )}
                  {sayfaYetkiKontrol('bacteria') && (
                    <button 
                      onClick={() => {
                        // 🚦 Bacteria AI kapalı — veri yetersizliği (constants/modulDurum.js)
                        if (!BACTERIA_AKTIF) { toast.info(BACTERIA_KAPALI_MESAJ); return; }
                        if (tabEnabled) { const fn = forceOpenTab || openTab; fn('/panel/bacteria'); navigate('/panel/bacteria'); }
                        else { navigate('/panel/bacteria'); }
                      }}
                      className={`flex items-center gap-1 text-[10px] font-bold px-2.5 py-1 rounded-full transition-all shadow-sm ${BACTERIA_AKTIF
                        ? 'bg-gradient-to-r from-purple-500 to-indigo-500 text-white hover:from-purple-400 hover:to-indigo-400 cursor-pointer'
                        : 'bg-slate-500/60 text-slate-200 cursor-not-allowed'}`}
                      title={BACTERIA_AKTIF ? 'Bacteria AI' : BACTERIA_KAPALI_MESAJ}
                      data-testid="sidebar-bacteria-btn"
                    >
                      <Dna size={10} /> Bacteria AI
                      {!BACTERIA_AKTIF && (
                        <span className="bg-white/20 text-[8px] px-1 py-0.5 rounded-full font-bold">{KAPALI_ETIKET}</span>
                      )}
                    </button>
                  )}
                  {sayfaYetkiKontrol('destek-talep') && (
                  <button 
                    onClick={() => { 
                      if (tabEnabled) { const fn = forceOpenTab || openTab; fn('/panel/destek-talep'); navigate('/panel/destek-talep'); } 
                      else { navigate('/panel/destek-talep'); }
                    }}
                    className="flex items-center gap-1 text-[10px] font-bold bg-gradient-to-r from-amber-500 to-orange-500 text-white px-2.5 py-1 rounded-full hover:from-amber-400 hover:to-orange-400 transition-all cursor-pointer shadow-sm"
                  >
                    <LifeBuoy size={10} /> Destek
                  </button>
                  )}
                </div>
              </div>
            )}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 hover:bg-indigo-700 rounded-lg transition text-white"
            >
              {isOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>

        {/* Yoldaki Ürünler Bildirim Bandı */}
        {yoldakiUrunSayisi > 0 && (
          <NavLink
            to="/panel/yoldaki-urunlerim"
            onClick={(e) => handleNavClick(e, '/panel/yoldaki-urunlerim')}
            data-testid="yoldaki-bildirim-banner"
            className="block sidebar-yoldaki-banner"
          >
            {isOpen ? (
              <div className="mx-3 mt-3 px-3 py-2.5 rounded-xl bg-gradient-to-r from-blue-500 to-cyan-500 text-white flex items-center gap-2.5 shadow-lg shadow-blue-500/25 cursor-pointer hover:shadow-blue-500/40 transition-shadow">
                <div className="relative flex-shrink-0">
                  <Ship size={20} className="sidebar-yoldaki-ship" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-bold leading-tight">{yoldakiUrunSayisi} ürün yolda!</p>
                  <p className="text-[10px] opacity-80 leading-tight">Tıkla ve takip et</p>
                </div>
                <span className="flex-shrink-0 bg-red-500 text-white text-xs font-bold w-7 h-7 rounded-full flex items-center justify-center sidebar-yoldaki-count">
                  {yoldakiUrunSayisi}
                </span>
              </div>
            ) : (
              <div className="flex justify-center mt-3">
                <div className="relative cursor-pointer sidebar-yoldaki-icon-pulse" title={`${yoldakiUrunSayisi} ürün yolda`}>
                  <Ship size={22} className="text-blue-500" />
                  <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center animate-pulse">
                    {yoldakiUrunSayisi}
                  </span>
                </div>
              </div>
            )}
          </NavLink>
        )}

        {/* 🔴 Eski kampanya banner'ı kaldırıldı (Görev 1).
            Artık kampanya bildirimi sepet altında mavi chip olarak gösteriliyor (Görev 2). */}

        {/* 🆕 v3.0210: Kalıcı "Size Özel Fırsat Şeridi" — yalnızca müşteri için */}
        {isMusteriKullanici && <FirsatSeridi isOpen={isOpen} user={user} />}

      <nav className="flex-1 overflow-y-auto p-3">
        <div className="space-y-1">
          {isSuper && pinliCount > 0 && isOpen && (
            <div className="px-2 pt-0.5 pb-1 text-[10px] font-bold text-amber-600 uppercase tracking-wider flex items-center gap-1">
              <Zap size={12} className="fill-amber-400" /> Hızlı Erişim
            </div>
          )}
          {siraliMenu.map((item, idx) => (
            <Fragment key={item.path}>
            {isSuper && pinliCount > 0 && idx === pinliCount && (
              <div className="my-2 border-t border-amber-200" />
            )}
            <NavLink
              to={item.path}
              onClick={(e) => handleNavClick(e, item.path)}
              title={kapaliModulMesaji(item.path) || item.label}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  kapaliModulMesaji(item.path)
                    ? 'text-gray-400 opacity-60 cursor-not-allowed hover:bg-transparent'
                    : isActive
                      ? 'bg-indigo-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-indigo-50'
                }`
              }
            >
              <div className="relative">
                <item.icon size={20} />
                {/* Sidebar kapalıyken de badge göster */}
                {!isOpen && item.badge > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] w-5 h-5 flex items-center justify-center rounded-full font-bold animate-pulse">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
                {/* Sidebar kapali - sepet altinda kampanya isareti */}
                {!isOpen && item.path === '/panel/sepetim' && sepetKampanya.kampanyali_sayi > 0 && (
                  <span
                    className="absolute -bottom-1.5 -right-1.5 bg-slate-800 text-sky-300 text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center border border-sky-400/40 shadow-md"
                    title={`${sepetKampanya.kampanyali_sayi} ürüne özel kampanya`}
                  >
                    %
                  </span>
                )}
              </div>
              {isOpen && (
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  <span className="text-sm font-medium flex-1 truncate">{item.label}</span>
                  {kapaliModulMesaji(item.path) && (
                    <span className="text-[8px] bg-gray-300 text-gray-700 px-1.5 py-0.5 rounded-full font-bold whitespace-nowrap">
                      {KAPALI_ETIKET}
                    </span>
                  )}
                  {item.badge !== undefined && item.badge > 0 && (
                    <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-bold animate-pulse">
                      {item.badge}
                    </span>
                  )}
                  {isSuper && (
                    <span
                      role="button"
                      title={qaSet.has(item.path) ? 'Hızlı erişimden çıkar' : 'Hızlı erişime ekle'}
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleHizliErisim(item.path); }}
                      className={`shrink-0 p-0.5 rounded transition ${qaSet.has(item.path) ? 'text-amber-500' : 'text-gray-300 hover:text-amber-500'}`}
                    >
                      <Star size={14} className={qaSet.has(item.path) ? 'fill-amber-400' : ''} />
                    </span>
                  )}
                </div>
              )}
            </NavLink>

            {/* Sepetteki kampanyali urun bildirimi — premium minimal */}
            {isOpen && item.path === '/panel/sepetim' && sepetKampanya.kampanyali_sayi > 0 && (
              <NavLink
                to="/panel/sepetim"
                onClick={(e) => handleNavClick(e, '/panel/sepetim')}
                data-testid="sepet-kampanya-chip"
                className="block -mt-0.5 ml-7 mr-1"
                title={`Sepetinizdeki ${sepetKampanya.kampanyali_sayi} üründe kampanya uygulanıyor`}
              >
                <div className="rounded-md bg-slate-800 border border-slate-700 px-2.5 py-1.5 hover:border-sky-400/40 hover:bg-slate-700 transition-colors cursor-pointer shadow-sm">
                  <div className="flex items-center gap-1.5">
                    <Percent size={10} strokeWidth={2.5} className="text-sky-400 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] font-semibold text-slate-100 leading-tight truncate">
                        {sepetKampanya.kampanyali_sayi === 1
                          ? '1 ürüne kampanya'
                          : `${sepetKampanya.kampanyali_sayi} ürüne kampanya`}
                      </p>
                      {sepetKampanya.toplam_tasarruf > 0 && (
                        <p className="text-[9px] text-sky-300 leading-tight truncate tabular-nums font-medium">
                          ₺{Math.round(sepetKampanya.toplam_tasarruf).toLocaleString('tr-TR')} tasarruf
                        </p>
                      )}
                    </div>
                    <span className="flex-shrink-0 text-sky-400 text-[9px] font-bold tabular-nums">
                      ·{sepetKampanya.kampanyali_sayi}
                    </span>
                  </div>
                </div>
              </NavLink>
            )}
            </Fragment>
          ))}

          {/* Sipariş Takibi - Müşteri için artık üst array'de (Siparişlerim + Ön Siparişlerim).
              Bu blok sadece Firma/Admin nested menüsü için kullanılıyor. */}
          {!isMusteriKullanici && (
            <div>
              <button
              onClick={() => {
                setSiparisMenuAcik(!siparisMenuAcik);
                if (!siparisMenuAcik) {
                  setSatisMenuAcik(true);
                  setSatinAlmaMenuAcik(true);
                }
              }}
                className="w-full flex items-center justify-between p-3 rounded-lg text-gray-700 hover:bg-indigo-50 transition"
              >
                
                <div className="flex items-center space-x-3">
                  <ShoppingCart size={20} />
                  {isOpen && (
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium">Sipariş Takibi</span>
                      {bekleyenSiparisler > 0 && (
                        <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-bold">
                          {bekleyenSiparisler}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                {isOpen && <span className="text-xs">{siparisMenuAcik ? '▼' : '▶'}</span>}
              </button>
              
              {isOpen && siparisMenuAcik && (
                <div className="ml-8 mt-1 space-y-1">
                  <NavLink
                    to="/panel/yeni-siparis"
              onClick={(e) => handleNavClick(e, '/panel/yeni-siparis')}
                    className={({ isActive }) => `block p-2 rounded text-sm ${isActive ? 'bg-rose-100 text-rose-700 font-medium' : 'text-gray-600 hover:bg-gray-100'}`}
                  >
                    ➕ Yeni Sipariş
                  </NavLink>
                  
                  {/* Satış Siparişleri */}
                  <div>
                    <button
                      onClick={() => setSatisMenuAcik(!satisMenuAcik)}
                      className="w-full flex items-center justify-between p-2 rounded text-sm text-gray-700 hover:bg-gray-100"
                    >
                      <span>📊 Satış Siparişleri</span>
                      <span className="text-xs">{satisMenuAcik ? '▼' : '▶'}</span>
                    </button>
                    {satisMenuAcik && (
                      <div className="ml-4 mt-1 space-y-1">
                        <NavLink to="/panel/siparisler/satis/bekleyen" className={({ isActive }) => `block p-1.5 rounded text-xs ${isActive ? 'bg-red-100 text-red-700 font-medium' : 'text-gray-600 hover:bg-gray-100'}`}>
                          <div className="flex items-center gap-1">
                       <span>Bekleyen</span>
                       {satisBekleyen > 0 && (
                         <span className="bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full font-bold">
                           {satisBekleyen}
                         </span>
                       )}
                     </div>
                        </NavLink>
                        <NavLink to="/panel/siparisler/satis/hazirlanan" className={({ isActive }) => `block p-1.5 rounded text-xs ${isActive ? 'bg-blue-100 text-blue-700 font-medium' : 'text-gray-600 hover:bg-gray-100'}`}>
                          Hazırlanan
                        </NavLink>
                        <NavLink to="/panel/siparisler/satis/tamamlanan" className={({ isActive }) => `block p-1.5 rounded text-xs ${isActive ? 'bg-green-100 text-green-700 font-medium' : 'text-gray-600 hover:bg-gray-100'}`}>
                          Tamamlanan
                        </NavLink>
                      </div>
                    )}
                  </div>
                  
                  {/* Satınalma Siparişleri */}
                  <div>
                    <button
                      onClick={() => setSatinAlmaMenuAcik(!satinAlmaMenuAcik)}
                      className="w-full flex items-center justify-between p-2 rounded text-sm text-gray-700 hover:bg-gray-100"
                    >
                      <span>📦 Satınalma Siparişleri</span>
                      <span className="text-xs">{satinAlmaMenuAcik ? '▼' : '▶'}</span>
                    </button>
                    {satinAlmaMenuAcik && (
                      <div className="ml-4 mt-1 space-y-1">
                        <NavLink to="/panel/siparisler/satin-alma/bekleyen" className={({ isActive }) => `block p-1.5 rounded text-xs ${isActive ? 'bg-red-100 text-red-700 font-medium' : 'text-gray-600 hover:bg-gray-100'}`}>
                         <div className="flex items-center gap-1">
                       <span>Bekleyen</span>
                       {satinAlmaBekleyen > 0 && (
                         <span className="bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full font-bold">
                           {satinAlmaBekleyen}
                         </span>
                       )}
                     </div>
                           </NavLink>
                        <NavLink to="/panel/siparisler/satin-alma/hazirlanan" className={({ isActive }) => `block p-1.5 rounded text-xs ${isActive ? 'bg-blue-100 text-blue-700 font-medium' : 'text-gray-600 hover:bg-gray-100'}`}>
                          Hazırlanan
                        </NavLink>
                        <NavLink to="/panel/siparisler/satin-alma/tamamlanan" className={({ isActive }) => `block p-1.5 rounded text-xs ${isActive ? 'bg-green-100 text-green-700 font-medium' : 'text-gray-600 hover:bg-gray-100'}`}>
                          Tamamlanan
                        </NavLink>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* 🛡 İç Kullanıcı Cihazları - admin/superadmin + müdür (müdür kendi firması) */}
          {user && ['admin', 'superadmin', 'mudur'].includes(userRole) && (
            <>
              <div className="my-2 border-t border-gray-200"></div>
              <NavLink
                to="/admin/ic-kullanicilar"
                onClick={(e) => handleNavClick(e, '/admin/ic-kullanicilar')}
                data-testid="sidebar-ic-kullanici-cihaz-link"
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-3 rounded-lg transition ${
                    isActive
                      ? 'bg-purple-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-purple-50'
                  }`
                }
              >
                <Shield size={20} />
                {isOpen && <span className="text-sm font-medium">🛡 İç Kullanıcı Cihazları</span>}
              </NavLink>
              <NavLink
                to="/panel/mobil-komuta"
                onClick={(e) => handleNavClick(e, '/panel/mobil-komuta')}
                data-testid="sidebar-mobil-komuta-link"
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-3 rounded-lg transition ${
                    isActive
                      ? 'bg-violet-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-violet-50'
                  }`
                }
              >
                <Smartphone size={20} />
                {isOpen && <span className="text-sm font-medium">📱 Mobil Komuta</span>}
              </NavLink>
            </>
          )}

          {/* ⏰ Mesai Dışı Onaylar — KİŞİ BAZLI tik (Kullanıcı Yönetimi → Yetkiler). İstekler firma
              müdürüne gidiyordu ama menü yalnız admin / superadmin'deydi (2026-10-01). */}
          {user && (userRole === 'superadmin' || sayfaGorebilir('mesai-disi') === true) && (
            <NavLink
              to="/admin/mesai-disi"
              onClick={(e) => handleNavClick(e, '/admin/mesai-disi')}
              data-testid="sidebar-mesai-disi-link"
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-purple-600 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-purple-50'
                }`
              }
            >
              <Clock size={20} />
              {isOpen && <span className="text-sm font-medium">⏰ Mesai Dışı Onaylar</span>}
            </NavLink>
          )}

          {/* Kullanıcı Yönetimi - admin ve superadmin için */}
          {user && ['admin', 'superadmin'].includes(userRole) && (
            <>
              <div className="my-2 border-t border-gray-200"></div>
              <NavLink
                to="/panel/kullanici-yonetimi"
              onClick={(e) => handleNavClick(e, '/panel/kullanici-yonetimi')}
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-3 rounded-lg transition ${
                    isActive
                      ? 'bg-indigo-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-indigo-50'
                  }`
                }
              >
                <Users size={20} />
                {isOpen && <span className="text-sm font-medium">👥 Kullanıcı Yönetimi</span>}
              </NavLink>

              {/* 🛡 Güvenlik Olayları (Feb 2026) */}
              <NavLink
                to="/panel/guvenlik-olaylari"
                onClick={(e) => handleNavClick(e, '/panel/guvenlik-olaylari')}
                data-testid="sidebar-guvenlik-olaylari-link"
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-3 rounded-lg transition ${
                    isActive
                      ? 'bg-red-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-red-50'
                  }`
                }
              >
                <Shield size={20} />
                {isOpen && <span className="text-sm font-medium">🛡 Güvenlik Olayları</span>}
              </NavLink>

              {/* 📋 Denetim Logu (Audit Log) (Feb 2026) */}
              <NavLink
                to="/panel/audit-log"
                onClick={(e) => handleNavClick(e, '/panel/audit-log')}
                data-testid="sidebar-audit-log-link"
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-3 rounded-lg transition ${
                    isActive
                      ? 'bg-indigo-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-indigo-50'
                  }`
                }
              >
                <Shield size={20} />
                {isOpen && <span className="text-sm font-medium">📋 Denetim Logu</span>}
              </NavLink>
            </>
          )}
              
          {/* Raporlar - mudur, admin, superadmin için */}
          {user && sayfaYetkiKontrol('raporlar') && (
            <>
              <NavLink
                to="/panel/raporlar"
              onClick={(e) => handleNavClick(e, '/panel/raporlar')}
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-3 rounded-lg transition ${
                    isActive
                      ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-purple-50'
                  }`
                }
              >
                <BarChart3 size={20} />
                {isOpen && <span className="text-sm font-medium">📊 Raporlar</span>}
              </NavLink>
            </>
          )}

          {/* Kredi Kartı Provizyon - mudur, admin, superadmin için */}
          {user && sayfaYetkiKontrol('kredi-karti-provizyon') && (
            <NavLink
              to="/panel/kredi-karti-provizyon"
              onClick={(e) => handleNavClick(e, '/panel/kredi-karti-provizyon')}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-gradient-to-r from-green-600 to-emerald-600 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-green-50'
                }`
              }
            >
              <CreditCard size={20} />
              {isOpen && <span className="text-sm font-medium">💳 Kredi Kartı Provizyon</span>}
            </NavLink>
          )}

          {/* Kasa (Nakit) - mudur, admin, superadmin için */}
          {user && sayfaYetkiKontrol('kasa') && (
            <NavLink
              to="/panel/kasa"
              onClick={(e) => handleNavClick(e, '/panel/kasa')}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-emerald-50'
                }`
              }
            >
              <Wallet size={20} />
              {isOpen && <span className="text-sm font-medium">💵 Kasa (Nakit)</span>}
            </NavLink>
          )}

          {/* Sistem Yönetimi - sadece admin ve superadmin için */}
          {user && sayfaYetkiKontrol('sistem-yonetimi') && (
            <NavLink
              to="/panel/sistem-yonetimi"
              onClick={(e) => handleNavClick(e, '/panel/sistem-yonetimi')}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-gradient-to-r from-slate-700 to-slate-800 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-slate-100'
                }`
              }
            >
              <Settings size={20} />
              {isOpen && <span className="text-sm font-medium">⚙️ Sistem Yönetimi</span>}
            </NavLink>
          )}

          {/* 🔎 Parça Arama (TecDoc) — superadmin + kişi bazlı tik (Kullanıcı Yönetimi; tiki yalnız superadmin verir) */}
          {user && (userRole === 'superadmin' || sayfaGorebilir('tecdoc') === true) && (
            <NavLink
              to="/panel/tecdoc"
              onClick={(e) => handleNavClick(e, '/panel/tecdoc')}
              data-testid="sidebar-tecdoc-link"
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-slate-800 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-slate-100'
                }`
              }
            >
              <ScanSearch size={20} />
              {isOpen && <span className="text-sm font-medium">🔎 Parça Arama (TecDoc)</span>}
            </NavLink>
          )}

          {/* Stok Cache Yeniden Yukle - sadece superadmin */}
          {user && (userRole === 'superadmin' || userRole === 'yetsanadmin') && (
            <NavLink
              to="/panel/stok-resync"
              onClick={(e) => handleNavClick(e, '/panel/stok-resync')}
              data-testid="sidebar-stok-resync-link"
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-indigo-50'
                }`
              }
            >
              <RefreshCw size={20} />
              {isOpen && <span className="text-sm font-medium">🔄 Stok Cache Yenile</span>}
            </NavLink>
          )}
          
          {/* WMS (Depo Yönetimi) - Sadece firma/admin kullanıcıları için (müşteriler göremez) */}
          {user && userRole !== 'client' && userRole !== 'musteri' && (
            <>
              <div className="my-2 border-t border-gray-200"></div>
              <NavLink
                to="/wms/ana-menu"
              onClick={(e) => handleNavClick(e, '/wms/ana-menu')}
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-3 rounded-lg transition ${
                    isActive
                      ? 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-teal-50'
                  }`
                }
              >
                <Warehouse size={20} />
                {isOpen && <span className="text-sm font-medium">🏭 Depo Yönetimi (WMS)</span>}
              </NavLink>
            </>
          )}
          
          {/* Taleplerim - client hariç tüm kullanıcılar için */}
          {user && userRole !== 'client' && sayfaYetkiKontrol('taleplerim') && (
            <NavLink
              to="/panel/taleplerim"
              onClick={(e) => handleNavClick(e, '/panel/taleplerim')}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition relative ${
                  isActive
                    ? 'bg-gradient-to-r from-indigo-500 to-purple-500 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-indigo-50'
                }`
              }
            >
              <Tag size={20} />
              {isOpen && <span className="text-sm font-medium">📋 Taleplerim</span>}
              {/* 🆕 Bekleyen talep sayısı badge */}
              {benimTaleplerimBekleyen > 0 && (
                <span className="absolute right-2 top-1/2 -translate-y-1/2 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
                  {benimTaleplerimBekleyen}
                </span>
              )}
            </NavLink>
          )}

          {/* Fiyat Talepleri (Yönetim) - mudur, admin, superadmin için */}
          {user && sayfaYetkiKontrol('fiyat-talepleri') && (
            <>
              <NavLink
                to="/panel/fiyat-talepleri"
              onClick={(e) => handleNavClick(e, '/panel/fiyat-talepleri')}
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-3 rounded-lg transition relative ${
                    isActive
                      ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-amber-50'
                  }`
                }
              >
                <Tag size={20} />
                {isOpen && <span className="text-sm font-medium">🏷️ Fiyat Talepleri (Onay)</span>}
                {/* 🆕 Bekleyen onay sayısı badge */}
                {bekleyenFiyatTalepleri > 0 && (
                  <span className="absolute right-2 top-1/2 -translate-y-1/2 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center animate-pulse">
                    {bekleyenFiyatTalepleri}
                  </span>
                )}
              </NavLink>
            </>
          )}

          {/* Kullanıcı Aktiviteleri - Admin kullanıcılar için */}
          {user && ['admin', 'superadmin', 'mudur'].includes(userRole) && (
            <NavLink
              to="/panel/kullanici-aktiviteleri"
              onClick={(e) => handleNavClick(e, '/panel/kullanici-aktiviteleri')}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-cyan-50'
                }`
              }
            >
              <BarChart3 size={20} />
              {isOpen && <span className="text-sm font-medium">📊 Kullanıcı Aktiviteleri</span>}
            </NavLink>
          )}

          {/* 🆕 Canlı Analitik Dashboard - Admin kullanıcılar için */}
          {user && ['admin', 'superadmin', 'mudur'].includes(userRole) && (
            <NavLink
              to="/panel/canli-analitik"
              onClick={(e) => handleNavClick(e, '/panel/canli-analitik')}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-orange-50'
                }`
              }
            >
              <Activity size={20} />
              {isOpen && <span className="text-sm font-medium">🔴 Canlı Analitik</span>}
            </NavLink>
          )}

          {/* Sistem Bildirimleri - Admin kullanıcılar için */}
          {user && ['admin', 'superadmin'].includes(userRole) && (
            <NavLink
              to="/panel/sistem-bildirimleri"
              onClick={(e) => handleNavClick(e, '/panel/sistem-bildirimleri')}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-purple-50'
                }`
              }
            >
              <Megaphone size={20} />
              {isOpen && <span className="text-sm font-medium">📢 Sistem Bildirimleri</span>}
            </NavLink>
          )}

          {/* Push Bildirim - Admin/Müdür: müşteriye mobil push */}
          {user && ['admin', 'superadmin', 'mudur', 'yetsanadmin', 'ithaladmin'].includes(userRole) && (
            <NavLink
              to="/panel/push-bildirim"
              onClick={(e) => handleNavClick(e, '/panel/push-bildirim')}
              className={({ isActive }) =>
                `flex items-center space-x-3 p-3 rounded-lg transition ${
                  isActive
                    ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-blue-50'
                }`
              }
            >
              <Bell size={20} />
              {isOpen && <span className="text-sm font-medium">🔔 Push Bildirim</span>}
            </NavLink>
          )}
        </div>
      </nav>

      {isOpen && (
        <div className="p-4 border-t border-gray-200 bg-gray-50">
          <div className="mb-2">
            <p className="text-xs font-semibold text-gray-800">{user?.name} {user?.surname}</p>
            <p className="text-xs text-gray-500">
              {user?.role === 'admin' && 'Admin'}
              {user?.role === 'firma' && `Firma: ${user?.firma}`}
              {user?.role === 'musteri' && 'Müşteri Paneli'}
            </p>
          </div>
          {/* 🏢 Vekaleten yönetim — "hangi firma adına çalışıyorum" seçici */}
          {(() => {
            const baglam = getFirmaBaglami();
            const yonetilen = baglam?.yonetilen || [];
            if (!yonetilen.length) return null;
            const kendi = baglam?.firma || '';
            const aktif = getAktifFirma() || kendi;
            const vekaleten = aktif && aktif !== kendi;
            return (
              <div className={`mb-2 rounded-lg p-2 border ${vekaleten ? 'bg-amber-100 border-amber-300' : 'bg-amber-50 border-amber-200'}`}>
                <label className="block text-[10px] font-bold text-amber-700 uppercase tracking-wide mb-1">Çalışılan Firma</label>
                <select
                  value={aktif}
                  onChange={(e) => { setAktifFirma(e.target.value === kendi ? '' : e.target.value); window.location.reload(); }}
                  className="w-full text-xs border border-amber-300 rounded-md px-2 py-1.5 bg-white text-amber-900 font-semibold"
                >
                  <option value={kendi}>{kendi} (kendi firmam)</option>
                  {yonetilen.map(f => (
                    <option key={f} value={f}>{f}{f === 'ISTANBUL' ? ' (Mert Oto)' : ''} — vekaleten</option>
                  ))}
                </select>
                {vekaleten && (
                  <p className="text-[10px] text-amber-800 mt-1 font-medium">⚠️ {aktif} adına çalışıyorsunuz</p>
                )}
              </div>
            );
          })()}
          <button
            onClick={() => {
              logout();
              window.location.href = '/login';
            }}
            className="w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded-lg flex items-center justify-center space-x-2 transition"
          >
            <LogOut size={16} />
            <span className="text-sm">Çıkış</span>
          </button>
          {/* KVKK aydınlatma, açık rızalar, çerez politikası (2026-10-23) — pages/YasalMetinler */}
          <NavLink to="/panel/yasal-metinler" className="block text-center text-[11px] text-gray-500 hover:text-gray-800 mt-2 underline underline-offset-2">
            Yasal Metinler
          </NavLink>
        </div>
      )}
    </div>
    </>
  );
};

export default PanelSidebar;
